
import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace, Getter, State } from "vuex-class"

import CaseFilters from "@/components/CaseList/CaseFilters.vue"
import SlideMenu from "@/components/SlideMenu.vue"
import QuickCreate from "@/components/CaseDetails/QuickCreate.vue"

import HeaderBar from "./HeaderBar.vue"
import SideBar from "./SideBar.vue"

import { CurrentUser, SystemUser } from "@/types/user"

import { ViewsService } from "@/services/viewsService"
import QuickCreateMenu from "./QuickCreateMenu.vue"

const caseStore = namespace("cases")

@Component({
	components: {
		"quick-create-menu": QuickCreateMenu,
		"case-filters": CaseFilters,
		"quick-create": QuickCreate,
		"header-bar": HeaderBar,
		"side-bar": SideBar
	}
})
export default class Page extends Vue {
	$refs!: {
		slideMenu: SlideMenu
	}

	@Prop(String) private readonly title!: string;

	@State
	public systemUser!: SystemUser | null

	@Getter("getMe")
	public me!: CurrentUser;

	@Getter("getHasIntegrations") hasIntegrations!: boolean

	@Getter("getScreenWidth")
	public screenWidth!: number;

	@caseStore.State viewsService!: ViewsService;

	@Getter("getCaseName") private readonly caseName!: string;
	@Getter("getRecordName") private readonly recordName!: string;

	private get hasFooterSlot (): boolean {
		return !!this.$slots["footer-left"] || !!this.$slots["footer-right"]
	}

	public get userName (): string {
		if (this.systemUser) return this.systemUser.name
		return this.me?.name ?? ""
	}
}

